import * as React from 'react';
import { colors } from '@/styles';

export type UploadArrowProps = {
  size: number | string;
  title: string;
  color: string;
};

export const UploadArrow = ({
  size = 16,
  title = 'Upload',
  color = colors.boulder,
}: Partial<UploadArrowProps>) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 9 13">
      {Boolean(title) && <title>{title}</title>}
      <path
        fill={color}
        d="M7.785 3.673 4.696.195A.592.592 0 0 0 4.258 0a.472.472 0 0 0-.135.019.543.543
        0 0 0-.333.213L.753 3.673a.584.584 0 0 0 .037.82.577.577 0 0 0
        .82-.045l2.067-2.329v7.092a.58.58 0 1 0 1.161 0V2.1l2.078 2.329a.584.584 0 1 0
        .872-.76l-.003.004ZM8.027 11.173H.592a.592.592 0 1 0 0 1.183h7.435a.592.592 0 1 0 0-1.183Z"
      />
    </svg>
  );
};
